import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `kubernetes`,

  name: {
    [LOCALES.EN_US]: `Kubernetes`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.platform, TYPES.runtime_environment],

  tags: [],
} as const satisfies TTerm
